import React, { memo } from "react";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";
import { RecommendationBadge } from "./RecommendationBadge";
import { StockPick } from "@/types/stock"; // Import the StockPick type

interface StockItemProps {
  stock: StockPick;
}

export const StockItem = memo(({ stock }: StockItemProps) => (
  <div className="border border-white/10 rounded-lg p-3 hover:bg-white/5 transition-colors">
    <div className="flex justify-between items-start">
      <div>
        <div className="flex items-center gap-2">
          <h3 className="font-medium text-white">{stock.symbol}</h3>
          <RecommendationBadge recommendation={stock.recommendation} />
          {stock.confidence > 0.8 && (
            <span title={`High Confidence (${(stock.confidence * 100).toFixed(0)}%)`}>
              <Sparkles className="h-3.5 w-3.5 text-yellow-400" />
            </span>
          )}
        </div>
        <p className="text-sm text-white/70 line-clamp-1" title={stock.companyName}>{stock.companyName}</p>
      </div>
      <div className="text-right">
        <div className="font-medium text-white">
          ${stock.price.toFixed(2)}
        </div>
        <div className={cn(
          "text-xs font-medium",
          stock.change_percent >= 0 ? "text-green-400" : "text-red-400"
        )}>
          {stock.change_percent >= 0 ? '+' : ''}{stock.change_percent.toFixed(2)}%
        </div>
      </div>
    </div>
    {stock.rationale && (
      <p className="text-xs text-muted-foreground mt-2 pt-2 border-t border-white/5 line-clamp-2" title={stock.rationale}>
        {stock.rationale}
      </p>
    )}
  </div>
));

StockItem.displayName = 'StockItem';

export default StockItem;
